import React from "react";
import LinearProgress from "@mui/material/LinearProgress";

export default function ProgressBar({ value, label, ...props }) {
  const percent =
    typeof value === "number" && Number.isFinite(value)
      ? Math.max(0, Math.min(100, value * 100))
      : null;
  return (
    <LinearProgress
      {...props}
      aria-label={label}
      variant={percent === null ? "indeterminate" : "determinate"}
      value={percent ?? undefined}
    />
  );
}
